<template>
  <section class="relative py-8 text-white bg-orangePantone">
    <ClientOnly>
      <!--footer top-->
      <div
        class="flex flex-wrap justify-center px-5 pb-3.5 mx-auto w-full max-w-screen-2xl lg:px-14 xl:px-20 2xl:px-12 md:pb-4 lg:justify-between">
        <div class="pb-4 mx-auto w-full lg:mx-0 lg:w-4/12 xl:pr-9">
          <div
            class="flex flex-wrap gap-x-4 justify-center items-center mx-auto text-center md:flex-nowrap lg:flex-wrap lg:justify-start md:text-left lg:pr-12 md:pr-0">
            <!--logo-->
            <a href="https://lifeboostcoffee.com/" target="_blank"
              class="inline-block top-6 left-1/2 mb-6 transform lg:translate-x-0 lg:mx-0 lg:static xl:mb-5 2xl:mb-2.5" aria-label="Go to Home Page">
              <nuxt-img class="" width="184px" loading="lazy" format="webp" height="67px"
                src="/assets/images/logo-footer.svg" alt="logo footer" />
            </a>
            <p class="text-sm leading-5 lg:pt-6" data-live-text-setting="footer_text" v-html="footerText"></p>
          </div>
        </div>
        <div
          class="flex relative flex-wrap justify-end items-center px-5 pt-3 mx-auto max-w-screen-2xl md:px-7 lg:px-14 xl:px-20 2xl:px-12 lg:pt-4 lg:w-8/12">
          <div
            class="flex flex-wrap justify-center items-center mb-6 w-full text-xs lg:w-auto lg:justify-start lg:text-sm lg:mb-0 md:space-x-12">
            <p class="block mb-3 w-full text-center md:w-auto md:mb-0" v-html="copyrightText"></p>
            <a :href="privacyPolicyLink" target="_blank"
              class="block w-1/2 text-center text-white md:w-auto hover:text-brownLatte" v-html="privacyPolicyText"></a>
            <a :href="termsLink" target="_blank"
              class="block w-1/2 text-center text-white md:w-auto hover:text-brownLatte" v-html="termsText"></a>
          </div>
          <div class="flex flex-wrap justify-center items-center space-x-3 w-full text-sm lg:w-auto lg:justify-end"></div>
        </div>
      </div>
      <!--footer bottom -->
    </ClientOnly>
  </section>
</template>

<script setup>

const props = defineProps({
  footerText: {
    type: String,
    default: 'Helping You Achieve the Healthiest, Tastiest Cup of Coffee Possible Using Sustainable Farming & Protecting Our Wildlife'
  },
  copyrightText: {
    type: String,
    default: '2025 © Lifeboost Group Inc.'
  },
  privacyPolicyLink: {
    type: String,
    default: 'https://lifeboostcoffee.com/pages/privacy'
  },
  privacyPolicyText: {
    type: String,
    default: 'Privacy Policy'
  },
  termsLink: {
    type: String,
    default: 'https://lifeboostcoffee.com/pages/terms'
  },
  termsText: {
    type: String,
    default: 'Terms & Conditions'
  }
});

defineBuilderComponent({
  friendlyName: "Footer Old",
  inputs: [
    {
      name: 'footerText',
      type: 'richText',
      defaultValue: 'Helping You Achieve the Healthiest, Tastiest Cup of Coffee Possible Using Sustainable Farming & Protecting Our Wildlife'
    },
    {
      name: 'copyrightText',
      type: 'richText',
      defaultValue: '2025 © Lifeboost Group Inc.'
    },
    {
      name: 'privacyPolicyLink',
      type: 'text',
      defaultValue: 'https://lifeboostcoffee.com/pages/privacy'
    },
    {
      name: 'privacyPolicyText',
      type: 'richText',
      defaultValue: 'Privacy Policy'
    },
    {
      name: 'termsLink',
      type: 'text',
      defaultValue: 'https://lifeboostcoffee.com/pages/terms'
    },
    {
      name: 'termsText',
      type: 'richText',
      defaultValue: 'Terms & Conditions'
    }
  ]
});
</script>

<style scoped>
/* Your styles here */
</style>